import { render } from "./KanbanCard.vue?vue&type=template&id=6e2979fc&scoped=true&ts=true"
import script from "./KanbanCard.vue?vue&type=script&lang=ts"
export * from "./KanbanCard.vue?vue&type=script&lang=ts"

import "./KanbanCard.vue?vue&type=style&index=0&id=6e2979fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2979fc"]])

export default __exports__